module.exports = __webpack_public_path__ + "img/use_selected.68df6eba.svg";